import { useAtomValue } from 'jotai'
import { FC, useMemo } from 'react'
import { PropertyRecordsDetailsDebts } from 'src/components/insights/property-records/details/debts'
import { UnavailableCardContent } from 'src/components/insights/unavailable-card-content'
import { sortDebts } from 'src/utils/property-records'
import { parcelPropertyRecords } from 'src/v2/state/owner-reveal/parcel-property-records'

export const ParcelPropertyDebtsContent: FC = () => {
  const data = useAtomValue(parcelPropertyRecords)

  const sortedData = useMemo(() => {
    if (!data) {
      return []
    }

    return sortDebts(data.debts)
  }, [data])

  if (!sortedData.length) {
    return <UnavailableCardContent message="Sorry, but we couldn't find the information requested for this parcel." />
  }

  return <PropertyRecordsDetailsDebts debts={sortedData} />
}
